webpackJsonp([61346034574736],{

/***/ 1951:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ProductMetadataField","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-product-metadata-field-1dc26a7cb3d1cd150aea.js